module.exports = __webpack_public_path__ + "static/img/AirRA800.da5e254.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AirRA800.png
// module id = R7Pc
// module chunks = 1